import { combineReducers } from '@reduxjs/toolkit'
import common from './commonSlice'
import dialog from './dialogSlice'

const reducer = combineReducers({
    common,
    dialog,
})

export default reducer
